module.exports = __webpack_public_path__ + "static/media/thumbnail.e66ba433.jpg";